import script from "./CareerDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerDetailView.vue?vue&type=script&setup=true&lang=js"

import "./CareerDetailView.vue?vue&type=style&index=0&id=19bf0c3e&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19bf0c3e"]])

export default __exports__